import React from 'react';
import { Grid } from '@mui/material';
import { Field } from 'formik';
import TextField from '@mui/material/TextField';
import { InputMoney } from '../../../../shared/components/InputMoney';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

interface TableProps {
  values: any;
  duploClick?: boolean;
  setFieldValue: any;
  /* [28/09] O edicaoRestrita SAIU daqui. Esta aba tem um campo so que ele governava,
     o "Gerar pedido ao finalizar", e ele passou a ter regra propria - mais larga, para
     que a flag possa ser ligada em A Faturar. Prop que ninguem le vira ruido. */
  podeEditarGerarPedido?: boolean;
}

const OrdemServicoFinalizar: React.FC<TableProps> = ({ values, duploClick, setFieldValue, podeEditarGerarPedido = false }) => (
  <Grid container spacing={2} sx={{ width: '80%', margin: '0 auto' }}>
    <Grid item xs={3}>
      <fieldset disabled={duploClick}>
        <Field
          name='qtdeItens'
          as={TextField}
          label='Qtd. Itens do Cliente'
          size='small'
          type='text'
          fullWidth
          value={values.itensJson.length}
          InputProps={{
            readOnly: true,
          }}
        />
      </fieldset>
    </Grid>

    <Grid item xs={3}>
      <fieldset disabled={duploClick}>
        <InputMoney
          name='totalProdutos'
          label='Total Produtos'
          fullWidth
          value={values.pecasjson
            .reduce((acc: any, item: any) => acc + parseFloat(item?.peca?.valorTotal || 0), 0)
            .toFixed(2)}
          disabled={true}
        />
      </fieldset>
    </Grid>

    <Grid item xs={3}>
      <fieldset disabled={duploClick}>
        <InputMoney
          name='totalServicos'
          label='Total Serviços'
          fullWidth
          value={values.servicosjson
            .reduce((acc: any, item: any) => acc + parseFloat(item?.servico?.valorTotal || 0), 0)
            .toFixed(2)}
          disabled={true}
        />
      </fieldset>
    </Grid>

    <Grid item xs={3}>
      <fieldset disabled={duploClick}>
        <InputMoney
          name='totalProdutosServicos'
          label='Total(produtos + serviços)'
          fullWidth
          value={(
            values.pecasjson.reduce(
              (acc: any, item: any) => acc + parseFloat(item?.peca?.valorTotal || 0),
              0
            ) +
            values.servicosjson.reduce(
              (acc: any, item: any) => acc + parseFloat(item?.servico?.valorTotal || 0),
              0
            )
          ).toFixed(2)}
          disabled={true}
        />
      </fieldset>
    </Grid>
    <Grid>
      <div style={{ padding: '16px' }}>
        <FormControlLabel control={<Checkbox checked={!!values.os_gerarPedido} disabled={duploClick || !podeEditarGerarPedido} onChange={(e, v) => setFieldValue('os_gerarPedido', v)} name='os_gerarPedido' {...{ slotProps: { input: { 'aria-label': 'Gerar Pedido ao Finalizar' } } }} />} label="Gerar Pedido ao Finalizar" />
      </div>
    </Grid>
  </Grid>
);

export default OrdemServicoFinalizar;
